import styled from 'styled-components';

export const FlightStopsContainer = styled.div`
  display: flex;
  align-items: flex-start;

  &:last-of-type .stopMeta {
    margin-left: 10px;
  }

  .dotDeparture {
    display: block;
    margin-bottom: 0px;
    width: 19px;
    height: 19px;
    border: 5px solid #009788;
    border-radius: 100%;
    box-sizing: border-box;
    background-clip: padding-box;
    transform: translateX(2px);
    max-width: unset;
  }

  .dotPath {
    background-color: #37ada2;
    width: 5px;
    height: 5px;
    margin-bottom: 5px;
    border-radius: 100%;
    background-clip: padding-box;
    display: block;
    transform: translateX(8px);
  }

  .dotPath:first-of-type {
    margin-top: 17px;
  }

  .dotPath:last-of-type {
    margin-bottom: 17px;
  }

  .stopMeta {
    margin-left: 15px;
    transform: translateY(-2px);
  }

  .time {
    margin-bottom: 10px;
    color: #009688;
    font-size: 20px;
  }

  .time span {
    color: #212121;
    font-size: 18px;
    font-weight: 700;
    margin-right: 7px;
  }

  .time {
    margin-bottom: 10px;
  }

  .codes {
    color: #939393;
    font-weight: 700;
    font-size: 16px;
    margin-bottom: 5px;
  }

  .codes span {
    color: #212121;
  }

  @media (min-width: 1024px) {
    .airport {
      font-size: 16px;
    }

    .time {
      margin-bottom: 10px;
    }
  }

  .airport {
    font-size: 15px;
    color: #212121;
    margin-bottom: 0;
  }

  .airport span {
    color: #939393;
  }
  .dotArrive {
    margin-left: -2px;
  }
`;
